// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@keyframes shimmer {
  0% {
    background-position: -200% 0;
  }
  100% {
    background-position: 200% 0;
  }
}
@keyframes shimmer-fade {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.table-shimmer {
  animation: shimmer-fade 0.5s ease-in;
}
.table-shimmer__title-section {
  margin-bottom: 1rem;
}
.table-shimmer__title {
  height: 24px;
  width: 65%;
  margin-bottom: 0.75rem;
}
.table-shimmer__subtitle {
  height: 16px;
  width: 45%;
}
.table-shimmer__wrapper {
  overflow-x: auto;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}
.table-shimmer__table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 0.875rem;
  background-color: #ffffff;
  background-color: var(--primary-color-light-500, #ffffff);
  border-radius: 8px;
}
.table-shimmer__thead {
  background-color: #f8f9fa;
  background-color: var(--primary-color-light-400, #f8f9fa);
  border-bottom: 2px solid #dee2e6;
  border-bottom: 2px solid var(--primary-color-dark-500, #dee2e6);
}
.table-shimmer__header-cell {
  padding: 0.75rem 1rem;
  text-align: left;
  border-bottom: 1px solid #dee2e6;
  border-bottom: 1px solid var(--primary-color-dark-500, #dee2e6);
  font-weight: 600;
}
.table-shimmer__header-cell:first-child {
  border-top-left-radius: 8px;
}
.table-shimmer__header-cell:last-child {
  border-top-right-radius: 8px;
}
.table-shimmer__header-cell .shimmer-line {
  height: 16px;
  width: 75%;
  max-width: 120px;
}
.table-shimmer__tbody {
  background-color: #ffffff;
  background-color: var(--primary-color-light-500, #ffffff);
}
.table-shimmer__row {
  border-bottom: 1px solid #f0f0f0;
  border-bottom: 1px solid var(--color-border-light, #f0f0f0);
}
.table-shimmer__row:last-child {
  border-bottom: none;
}
.table-shimmer__row:last-child td:first-child {
  border-bottom-left-radius: 8px;
}
.table-shimmer__row:last-child td:last-child {
  border-bottom-right-radius: 8px;
}
.table-shimmer__row:hover {
  background-color: #f8f9fa;
  background-color: var(--primary-color-light-400, #f8f9fa);
}
.table-shimmer__cell {
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #f0f0f0;
  border-bottom: 1px solid var(--color-border-light, #f0f0f0);
}
.table-shimmer__cell .shimmer-line {
  height: 14px;
}
.table-shimmer__cell:nth-child(1) .shimmer-line {
  width: 85%;
  max-width: 180px;
}
.table-shimmer__cell:nth-child(2) .shimmer-line {
  width: 70%;
  max-width: 140px;
}
.table-shimmer__cell:nth-child(3) .shimmer-line {
  width: 75%;
  max-width: 160px;
}
.table-shimmer__cell:nth-child(4) .shimmer-line {
  width: 60%;
  max-width: 120px;
}

.shimmer-line {
  background: linear-gradient(90deg, #e9ecef 25%, #f1f3f5 50%, #e9ecef 75%);
  background: linear-gradient(90deg, var(--color-background-tertiary, #e9ecef) 25%, var(--color-background-secondary, #f1f3f5) 50%, var(--color-background-tertiary, #e9ecef) 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 4px;
}`, "",{"version":3,"sources":["webpack://./src/layouts/user/Research/components/ChatContentView/TableShimmer/TableShimmer.scss"],"names":[],"mappings":"AAAA;EACE;IACE,4BAAA;EACF;EACA;IACE,2BAAA;EACF;AACF;AAEA;EACE;IACE,UAAA;EAAF;EAEA;IACE,UAAA;EAAF;AACF;AAGA;EACE,oCAAA;AADF;AAGE;EACE,mBAAA;AADJ;AAIE;EACE,YAAA;EACA,UAAA;EACA,sBAAA;AAFJ;AAKE;EACE,YAAA;EACA,UAAA;AAHJ;AAME;EACE,gBAAA;EACA,wCAAA;EACA,kBAAA;AAJJ;AAOE;EACE,WAAA;EACA,yBAAA;EACA,iBAAA;EACA,mBAAA;EACA,yBAAA;EAAA,yDAAA;EACA,kBAAA;AALJ;AAQE;EACE,yBAAA;EAAA,yDAAA;EACA,gCAAA;EAAA,+DAAA;AANJ;AASE;EACE,qBAAA;EACA,gBAAA;EACA,gCAAA;EAAA,+DAAA;EACA,gBAAA;AAPJ;AASI;EACE,2BAAA;AAPN;AAUI;EACE,4BAAA;AARN;AAWI;EACE,YAAA;EACA,UAAA;EACA,gBAAA;AATN;AAaE;EACE,yBAAA;EAAA,yDAAA;AAXJ;AAcE;EACE,gCAAA;EAAA,2DAAA;AAZJ;AAcI;EACE,mBAAA;AAZN;AAcM;EACE,8BAAA;AAZR;AAeM;EACE,+BAAA;AAbR;AAiBI;EACE,yBAAA;EAAA,yDAAA;AAfN;AAmBE;EACE,qBAAA;EACA,gCAAA;EAAA,2DAAA;AAjBJ;AAmBI;EACE,YAAA;AAjBN;AAoBI;EACE,UAAA;EACA,gBAAA;AAlBN;AAqBI;EACE,UAAA;EACA,gBAAA;AAnBN;AAsBI;EACE,UAAA;EACA,gBAAA;AApBN;AAuBI;EACE,UAAA;EACA,gBAAA;AArBN;;AA0BA;EACE,yEAAA;EAAA,gLAAA;EAMA,0BAAA;EACA,gCAAA;EACA,kBAAA;AA5BF","sourcesContent":["@keyframes shimmer {\n  0% {\n    background-position: -200% 0;\n  }\n  100% {\n    background-position: 200% 0;\n  }\n}\n\n@keyframes shimmer-fade {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.table-shimmer {\n  animation: shimmer-fade 0.5s ease-in;\n  \n  &__title-section {\n    margin-bottom: 1rem;\n  }\n  \n  &__title {\n    height: 24px;\n    width: 65%;\n    margin-bottom: 0.75rem;\n  }\n  \n  &__subtitle {\n    height: 16px;\n    width: 45%;\n  }\n  \n  &__wrapper {\n    overflow-x: auto;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n    border-radius: 8px;\n  }\n  \n  &__table {\n    width: 100%;\n    border-collapse: separate;\n    border-spacing: 0;\n    font-size: 0.875rem;\n    background-color: var(--primary-color-light-500, #ffffff);\n    border-radius: 8px;\n  }\n  \n  &__thead {\n    background-color: var(--primary-color-light-400, #f8f9fa);\n    border-bottom: 2px solid var(--primary-color-dark-500, #dee2e6);\n  }\n  \n  &__header-cell {\n    padding: 0.75rem 1rem;\n    text-align: left;\n    border-bottom: 1px solid var(--primary-color-dark-500, #dee2e6);\n    font-weight: 600;\n    \n    &:first-child {\n      border-top-left-radius: 8px;\n    }\n    \n    &:last-child {\n      border-top-right-radius: 8px;\n    }\n    \n    .shimmer-line {\n      height: 16px;\n      width: 75%;\n      max-width: 120px;\n    }\n  }\n  \n  &__tbody {\n    background-color: var(--primary-color-light-500, #ffffff);\n  }\n  \n  &__row {\n    border-bottom: 1px solid var(--color-border-light, #f0f0f0);\n    \n    &:last-child {\n      border-bottom: none;\n      \n      td:first-child {\n        border-bottom-left-radius: 8px;\n      }\n      \n      td:last-child {\n        border-bottom-right-radius: 8px;\n      }\n    }\n    \n    &:hover {\n      background-color: var(--primary-color-light-400, #f8f9fa);\n    }\n  }\n  \n  &__cell {\n    padding: 0.75rem 1rem;\n    border-bottom: 1px solid var(--color-border-light, #f0f0f0);\n    \n    .shimmer-line {\n      height: 14px;\n    }\n    \n    &:nth-child(1) .shimmer-line {\n      width: 85%;\n      max-width: 180px;\n    }\n    \n    &:nth-child(2) .shimmer-line {\n      width: 70%;\n      max-width: 140px;\n    }\n    \n    &:nth-child(3) .shimmer-line {\n      width: 75%;\n      max-width: 160px;\n    }\n    \n    &:nth-child(4) .shimmer-line {\n      width: 60%;\n      max-width: 120px;\n    }\n  }\n}\n\n.shimmer-line {\n  background: linear-gradient(\n    90deg,\n    var(--color-background-tertiary, #e9ecef) 25%,\n    var(--color-background-secondary, #f1f3f5) 50%,\n    var(--color-background-tertiary, #e9ecef) 75%\n  );\n  background-size: 200% 100%;\n  animation: shimmer 1.5s infinite;\n  border-radius: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
